"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("./utils");
var _ServiceTypesCheckbox = _interopRequireDefault(require("./components/ServiceTypesCheckbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ServiceTypesCheckboxes = /*#__PURE__*/function (_Component) {
  _inherits(ServiceTypesCheckboxes, _Component);
  var _super = _createSuper(ServiceTypesCheckboxes);
  function ServiceTypesCheckboxes(props) {
    var _this;
    _classCallCheck(this, ServiceTypesCheckboxes);
    _this = _super.call(this, props);
    _this.onServiceTypeCheckboxChange = _this.onServiceTypeCheckboxChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ServiceTypesCheckboxes, [{
    key: "onServiceTypeCheckboxChange",
    value: function onServiceTypeCheckboxChange(item, level) {
      var _this$props = this.props,
        autoSelectChildren = _this$props.autoSelectChildren,
        autoSelectParent = _this$props.autoSelectParent,
        field = _this$props.field,
        options = _this$props.options,
        valueKey = _this$props.valueKey;
      var newValue = (0, _utils.addOrRemoveParentChildren)(item, field.value, valueKey, options, level, autoSelectParent, autoSelectChildren);
      field.onChange(newValue);
      this.props.onChange(newValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        options = _this$props2.options,
        field = _this$props2.field,
        labelKey = _this$props2.labelKey,
        valueKey = _this$props2.valueKey,
        label = _this$props2.label,
        id = _this$props2.id,
        hideLabel = _this$props2.hideLabel,
        autoSelectParent = _this$props2.autoSelectParent,
        autoSelectChildren = _this$props2.autoSelectChildren;
      var labelClass = function labelClass() {
        return (0, _classnames["default"])({
          'control-label': true,
          'sr-only': hideLabel
        });
      };
      return /*#__PURE__*/_react["default"].createElement("fieldset", {
        className: "service-types-checkboxes"
      }, /*#__PURE__*/_react["default"].createElement("legend", {
        className: labelClass(),
        htmlFor: id
      }, label), /*#__PURE__*/_react["default"].createElement("div", {
        className: "service-types-checkboxes__container",
        id: id
      }, options.map(function (opt, index) {
        var key = "parent-".concat(index);
        return /*#__PURE__*/_react["default"].createElement(_ServiceTypesCheckbox["default"], {
          key: key,
          index: index,
          onChange: _this2.onServiceTypeCheckboxChange,
          id: "".concat(id, "-").concat(index),
          item: opt,
          labelKey: labelKey,
          valueKey: valueKey,
          value: field.value,
          autoSelectParent: autoSelectParent,
          autoSelectChildren: autoSelectChildren,
          allOptions: options
        });
      })));
    }
  }]);
  return ServiceTypesCheckboxes;
}(_react.Component);
ServiceTypesCheckboxes.propTypes = {
  /** boolean used to determine if all children of a service type should be selected when parent is selected */
  autoSelectChildren: _propTypes["default"].bool.isRequired,
  /** boolean used to determine if the child service type parent should be selected when the child is selected */
  autoSelectParent: _propTypes["default"].bool.isRequired,
  /** form field */
  field: _propTypes["default"].object.isRequired,
  /** boolean used to determine if the individual checkbox label should be hidden */
  hideLabel: _propTypes["default"].bool.isRequired,
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** label used in legend */
  label: _propTypes["default"].string.isRequired,
  /** Key used for the label of the checkboxes */
  labelKey: _propTypes["default"].string,
  /** function to be called when Component onServiceTypeCheckboxChange is called */
  onChange: _propTypes["default"].func,
  /** service type options */
  options: _propTypes["default"].array,
  /** Key used for the value of the checkboxes */
  valueKey: _propTypes["default"].string
};
ServiceTypesCheckboxes.defaultProps = {
  autoSelectChildren: false,
  autoSelectParent: false,
  hideLabel: false,
  labelKey: 'name',
  options: [],
  valueKey: 'id',
  onChange: _lodash.noop
};
var _default = exports["default"] = ServiceTypesCheckboxes;